import { ReconfigureAgentSchedulerFormController } from '../controller/ReconfigureAgentSchedulerFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { RecurrenceType, RECURRENCE_OPTIONS, SchedulerDataResponse } from '../types';
import { SchedulerMode } from '../types/SchedulerMode';

export class ReconfigureAgentSchedulerFormWebComponent extends BaseWebComponentElement {
  public controller!: ReconfigureAgentSchedulerFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ReconfigureAgentSchedulerFormController,
    });
  }

  private handleResponseScheduledDeployScenarios(response: SchedulerDataResponse): SchedulerDataResponse {
    if (!response.settings.specifics.scheduler.scheduledDeploy) {
      delete response.settings.specifics.scheduler.scheduleType;
      delete response.settings.specifics.scheduler.everyHour;
      delete response.settings.specifics.scheduler.startTime;
      delete response.settings.specifics.scheduler.dayOfWeek;
    } else {
      switch (response.settings.specifics.scheduler.scheduleType) {
        case RECURRENCE_OPTIONS[RecurrenceType.ByHour].value:
          delete response.settings.specifics.scheduler.startTime;
          delete response.settings.specifics.scheduler.dayOfWeek;
          break;
        case RECURRENCE_OPTIONS[RecurrenceType.Daily].value:
          delete response.settings.specifics.scheduler.everyHour;
          delete response.settings.specifics.scheduler.dayOfWeek;
          break;
        case RECURRENCE_OPTIONS[RecurrenceType.Weekly].value:
          delete response.settings.specifics.scheduler.everyHour;
          break;
      }
    }
    return response;
  }

  public get value(): SchedulerDataResponse {
    const formValues: object = this.controller.view.formGroup.value;
    let startHour = '' + formValues['settings']['specifics']['scheduler']['startTime'].hours;
    let startMinute = '' + formValues['settings']['specifics']['scheduler']['startTime'].minutes;
    if (startHour.length === 1) {
      startHour = startHour.padStart(2, '0');
    }
    if (startMinute.length === 1) {
      startMinute = startMinute.padStart(2, '0');
    }
    const startTimeToString = `${startHour}:${startMinute}`;
    const convertedDataFields: SchedulerDataResponse = {
      settings: {
        specifics: {
          scheduler: {
            scheduledDeploy: formValues['settings']['specifics']['scheduler']['scheduledDeploy'] !== SchedulerMode.Now,
            dayOfWeek: formValues['settings']['specifics']['scheduler']['dayOfWeek'][0],
            startTime: startTimeToString,
          },
        },
      },
    };
    let response: SchedulerDataResponse = _.merge(formValues, convertedDataFields);

    response = this.handleResponseScheduledDeployScenarios(response);
    return response;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup?.valid$;
  }
}
